export default __webpack_public_path__ + "static/media/my-certifications.4f59166a.svg";